// Les boutons d'amitié : « Ajouter en ami », « Confirmer », « ✓ Amis »…
//
// Le même couple de boutons apparaît dans l'annuaire, dans les suggestions et
// sur les profils. Dans le monde d'avant, on fabriquait leur HTML avec des
// attributs `data-ami` et un seul écouteur posé sur toute la page attrapait les
// clics : il fallait que l'écran écrive le bon attribut ET n'oublie pas de
// brancher l'écouteur. Ici le bouton porte lui-même ce qu'il fait.
//
// Ce qu'il fait, en revanche, reste écrit une seule fois — dans `agirAmitie`,
// partagé avec les écrans encore en HTML.

import { useState } from "react";
import { agirAmitie } from "../views/amis.js";
import { toast } from "../ui.js";

// Ce que propose chaque état de la relation. Un état = une intention lisible.
const SELON_ETAT = {
  amis: [{ action: "retirer", classe: "btn--fantome", texte: "✓ Amis" }],
  envoyee: [{ action: "annuler", classe: "btn--fantome", texte: "⏳ Demande envoyée" }],
  recue: [
    { action: "accepter", classe: "btn--primaire", texte: "✓ Confirmer" },
    { action: "refuser", classe: "btn--fantome", texte: "Supprimer" },
  ],
  aucun: [{ action: "demander", classe: "btn--primaire", texte: "➕ Ajouter en ami" }],
};

/**
 * @param {object} p
 * @param {string} p.etat   ce que rend `etatAmitie` : amis | envoyee | recue | aucun
 * @param {string} p.uid    le membre concerné
 * @param {string} p.nom    son nom, pour les demandes de confirmation
 * @param {boolean} p.petit taille réduite, dans les listes
 */
export default function BoutonsAmitie({ etat, uid, nom = "", petit = true, ctx }) {
  // Le temps d'un aller-retour au serveur, le bouton doit refuser un second
  // clic : deux « Ajouter en ami » d'affilée, c'est le doublon qu'on a déjà
  // payé une fois à l'inscription.
  const [enCours, setEnCours] = useState(false);

  const cliquer = async (action) => {
    if (enCours) return;
    setEnCours(true);
    try {
      await agirAmitie(action, uid, nom, ctx);
    } catch (err) {
      toast(err.message || "Action impossible", "erreur");
    }
    // L'abonnement va redessiner ces boutons avec le nouvel état ; s'il ne le
    // fait pas (action annulée, échec), il faut les rendre au membre.
    setEnCours(false);
  };

  return (SELON_ETAT[etat] || SELON_ETAT.aucun).map((b) => (
    <button
      key={b.action}
      className={`btn ${b.classe}${petit ? " btn--petit" : ""}`}
      disabled={enCours}
      onClick={() => cliquer(b.action)}
    >
      {b.texte}
    </button>
  ));
}
